// Helper to render a translated contest title given the contest object and t function.
// Handles the {month_num -> months.{N}} indirection.
export function renderContestTitle(c, t) {
  if (!c?.title_key) return c?.title || "";
  const params = { ...(c.title_params || {}) };
  if (params.month_num !== undefined && params.month_num !== null) {
    params.month = t(`months.${params.month_num}`);
  }
  return t(c.title_key, params);
}
